"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Coordinate = _interopRequireDefault(require("../../geom/Coordinate"));

var _Polygon = _interopRequireDefault(require("../../geom/Polygon"));

var _RectangleLineIntersector = _interopRequireDefault(require("../../algorithm/RectangleLineIntersector"));

var _ShortCircuitedGeometryVisitor = _interopRequireDefault(require("../../geom/util/ShortCircuitedGeometryVisitor"));

var _SimplePointInAreaLocator = _interopRequireDefault(require("../../algorithm/locate/SimplePointInAreaLocator"));

var _LinearComponentExtracter = _interopRequireDefault(require("../../geom/util/LinearComponentExtracter"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var RectangleIntersects =
/*#__PURE__*/
function () {
  function RectangleIntersects() {
    _classCallCheck(this, RectangleIntersects);

    RectangleIntersects.constructor_.apply(this, arguments);
  }

  _createClass(RectangleIntersects, [{
    key: "intersects",
    value: function intersects(geom) {
      if (!this._rectEnv.intersects(geom.getEnvelopeInternal())) return false;
      var visitor = new EnvelopeIntersectsVisitor(this._rectEnv);
      visitor.applyTo(geom);
      if (visitor.intersects()) return true;
      var ecpVisitor = new GeometryContainsPointVisitor(this._rectangle);
      ecpVisitor.applyTo(geom);
      if (ecpVisitor.containsPoint()) return true;
      var riVisitor = new RectangleIntersectsSegmentVisitor(this._rectangle);
      riVisitor.applyTo(geom);
      if (riVisitor.intersects()) return true;
      return false;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RectangleIntersects;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }], [{
    key: "intersects",
    value: function intersects(rectangle, b) {
      var rp = new RectangleIntersects(rectangle);
      return rp.intersects(b);
    }
  }]);

  return RectangleIntersects;
}();

exports.default = RectangleIntersects;

RectangleIntersects.constructor_ = function () {
  this._rectangle = null;
  this._rectEnv = null;
  var rectangle = arguments[0];
  this._rectangle = rectangle;
  this._rectEnv = rectangle.getEnvelopeInternal();
};

var EnvelopeIntersectsVisitor =
/*#__PURE__*/
function (_ShortCircuitedGeomet) {
  _inherits(EnvelopeIntersectsVisitor, _ShortCircuitedGeomet);

  function EnvelopeIntersectsVisitor() {
    var _this;

    _classCallCheck(this, EnvelopeIntersectsVisitor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(EnvelopeIntersectsVisitor).call(this));
    EnvelopeIntersectsVisitor.constructor_.apply(_assertThisInitialized(_this), arguments);
    return _this;
  }

  _createClass(EnvelopeIntersectsVisitor, [{
    key: "isDone",
    value: function isDone() {
      return this._intersects === true;
    }
  }, {
    key: "visit",
    value: function visit(element) {
      var elementEnv = element.getEnvelopeInternal();

      if (!this._rectEnv.intersects(elementEnv)) {
        return null;
      }

      if (this._rectEnv.contains(elementEnv)) {
        this._intersects = true;
        return null;
      }

      if (elementEnv.getMinX() >= this._rectEnv.getMinX() && elementEnv.getMaxX() <= this._rectEnv.getMaxX()) {
        this._intersects = true;
        return null;
      }

      if (elementEnv.getMinY() >= this._rectEnv.getMinY() && elementEnv.getMaxY() <= this._rectEnv.getMaxY()) {
        this._intersects = true;
        return null;
      }
    }
  }, {
    key: "intersects",
    value: function intersects() {
      return this._intersects;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return EnvelopeIntersectsVisitor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return EnvelopeIntersectsVisitor;
}(_ShortCircuitedGeometryVisitor.default);

EnvelopeIntersectsVisitor.constructor_ = function () {
  this._rectEnv = null;
  this._intersects = false;
  var rectEnv = arguments[0];
  this._rectEnv = rectEnv;
};

var GeometryContainsPointVisitor =
/*#__PURE__*/
function (_ShortCircuitedGeomet2) {
  _inherits(GeometryContainsPointVisitor, _ShortCircuitedGeomet2);

  function GeometryContainsPointVisitor() {
    var _this2;

    _classCallCheck(this, GeometryContainsPointVisitor);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(GeometryContainsPointVisitor).call(this));
    GeometryContainsPointVisitor.constructor_.apply(_assertThisInitialized(_this2), arguments);
    return _this2;
  }

  _createClass(GeometryContainsPointVisitor, [{
    key: "isDone",
    value: function isDone() {
      return this._containsPoint === true;
    }
  }, {
    key: "visit",
    value: function visit(geom) {
      if (!(geom instanceof _Polygon.default)) return null;
      var elementEnv = geom.getEnvelopeInternal();
      if (!this._rectEnv.intersects(elementEnv)) return null;
      var rectPt = new _Coordinate.default();

      for (var i = 0; i < 4; i++) {
        this._rectSeq.getCoordinate(i, rectPt);

        if (!elementEnv.contains(rectPt)) continue;

        if (_SimplePointInAreaLocator.default.containsPointInPolygon(rectPt, geom)) {
          this._containsPoint = true;
          return null;
        }
      }
    }
  }, {
    key: "containsPoint",
    value: function containsPoint() {
      return this._containsPoint;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return GeometryContainsPointVisitor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return GeometryContainsPointVisitor;
}(_ShortCircuitedGeometryVisitor.default);

GeometryContainsPointVisitor.constructor_ = function () {
  this._rectSeq = null;
  this._rectEnv = null;
  this._containsPoint = false;
  var rectangle = arguments[0];
  this._rectSeq = rectangle.getExteriorRing().getCoordinateSequence();
  this._rectEnv = rectangle.getEnvelopeInternal();
};

var RectangleIntersectsSegmentVisitor =
/*#__PURE__*/
function (_ShortCircuitedGeomet3) {
  _inherits(RectangleIntersectsSegmentVisitor, _ShortCircuitedGeomet3);

  function RectangleIntersectsSegmentVisitor() {
    var _this3;

    _classCallCheck(this, RectangleIntersectsSegmentVisitor);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(RectangleIntersectsSegmentVisitor).call(this));
    RectangleIntersectsSegmentVisitor.constructor_.apply(_assertThisInitialized(_this3), arguments);
    return _this3;
  }

  _createClass(RectangleIntersectsSegmentVisitor, [{
    key: "intersects",
    value: function intersects() {
      return this._hasIntersection;
    }
  }, {
    key: "isDone",
    value: function isDone() {
      return this._hasIntersection === true;
    }
  }, {
    key: "visit",
    value: function visit(geom) {
      var elementEnv = geom.getEnvelopeInternal();
      if (!this._rectEnv.intersects(elementEnv)) return null;

      var lines = _LinearComponentExtracter.default.getLines(geom);

      this.checkIntersectionWithLineStrings(lines);
    }
  }, {
    key: "checkIntersectionWithLineStrings",
    value: function checkIntersectionWithLineStrings(lines) {
      for (var i = lines.iterator(); i.hasNext();) {
        var testLine = i.next();
        this.checkIntersectionWithSegments(testLine);
        if (this._hasIntersection) return null;
      }
    }
  }, {
    key: "checkIntersectionWithSegments",
    value: function checkIntersectionWithSegments(testLine) {
      var seq1 = testLine.getCoordinateSequence();

      for (var j = 1; j < seq1.size(); j++) {
        seq1.getCoordinate(j - 1, this._p0);
        seq1.getCoordinate(j, this._p1);

        if (this._rectIntersector.intersects(this._p0, this._p1)) {
          this._hasIntersection = true;
          return null;
        }
      }
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return RectangleIntersectsSegmentVisitor;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);

  return RectangleIntersectsSegmentVisitor;
}(_ShortCircuitedGeometryVisitor.default);

RectangleIntersectsSegmentVisitor.constructor_ = function () {
  this._rectEnv = null;
  this._rectIntersector = null;
  this._hasIntersection = false;
  this._p0 = new _Coordinate.default();
  this._p1 = new _Coordinate.default();
  var rectangle = arguments[0];
  this._rectEnv = rectangle.getEnvelopeInternal();
  this._rectIntersector = new _RectangleLineIntersector.default(this._rectEnv);
};